import HoldInformationModal from '../../../holdInformation/views/HoldInformationModal';
import HoldInformationModalV2 from '../../../holdInformationV2/HoldInformationModalV2';
import HoldInformationV2 from '../../../holdInformationV2/HoldInformationV2';

import CopiesAvailableTemplate from '../../templates/CopiesAvailable.html';

export default class CopiesAvailable extends Backbone.View {
    constructor({ withIcons }) {
        super(...arguments);
        this.title = this.model.toJSON();
        this.withIcons = withIcons;
        this.listenTo(this.model, 'change:titleState', this._maybeRender);
        this.render();
    }

    events() {
        return {
            'click .js-holds-ratio-help-icon': '_renderModal',
        };
    }

    render() {
        this.$el.empty();
        if (this.model.allCopiesAreLuckyDay) {
            return this;
        }

        if (this.title.titleState === 'unavailable') {
            this._renderNormal();
            return this;
        } else if (this.title.isPreReleaseTitle) {
            this._renderNormal();
            return this;
        }

        switch (this.title.availabilityType) {
            case 'normal':
                this._renderNormal();
                break;
            case 'always':
                this.$el.append(
                    CopiesAvailableTemplate({
                        withIcons: this.withIcons,
                        availabilityText: window.text('cover.alwaysAvailable'),
                    })
                );
                break;
            case 'limited' && !this.title.isAvailable:
                this.$el.append(
                    CopiesAvailableTemplate({
                        withIcons: this.withIcons,
                        availabilityText: window.text(
                            'cover.limitedAvailability'
                        ),
                    })
                );
                break;
        }

        return this;
    }

    _maybeRender() {
        if (
            (window.featureManager.isEnabled('betterPatronState')
                ? this.model.get('isOnHold')
                : this.model.get('titleState') === 'onHold') ||
            (window.featureManager.isEnabled('betterPatronState')
                ? this.model.get('isBorrowed')
                : this.model.get('titleState') === 'borrowed')
        ) {
            this.render();
        }

        if (this.model.allCopiesAreLuckyDay) {
            this.render();
        }
    }

    _renderNormal() {
        let availabilityText, waitingText, helpButtonHTML;

        const notHeldClass = (
            window.featureManager.isEnabled('betterPatronState')
                ? this.model.get('isOnHold')
                : this.model.get('titleState') === 'onHold'
        )
            ? ''
            : 'js-holds-ratio-not-held';

        if (
            this.title.type.id === 'periodicals' &&
            this.title.availableCopies < 1 &&
            !this.title.isAvailable
        ) {
            availabilityText = window.html('cover.limitedAvailability');
            helpButtonHTML = `
                <button
                aria-label="${window.html('cover.whyLimitedAvailability')}"
                data-reveal-id="limited-periodical-availability"
                class="help-tip primary">
                </button>
                `;
        } else {
            let copyVariables = {
                availableCopies: window.featureManager.isEnabled('LuckyDay')
                    ? this.title.availableCopies +
                      this.title.luckyDayAvailableCopies
                    : this.title.availableCopies,
                ownedCopies: window.featureManager.isEnabled('LuckyDay')
                    ? this.title.ownedCopies + this.title.luckyDayOwnedCopies
                    : this.title.ownedCopies,
            };
            availabilityText = window.html(
                'cover.copiesAvailable',
                copyVariables
            );

            if (
                this.model.allCopiesAreLuckyDay &&
                this.title.titleState === 'unavailable'
            ) {
                availabilityText = window.html('cover.copiesAvailable', {
                    availableCopies: 0,
                    ownedCopies: this.title.luckyDayOwnedCopies,
                });
            }

            if (
                !this.title.isAvailable &&
                !this.model.hasAvailableLuckyDayCopies
            ) {
                if (!this.model.allCopiesAreLuckyDay) {
                    if (window.featureManager.isEnabled('LHTNG-2863')) {
                        if (this.title.isOwned) {
                            waitingText = new HoldInformationV2({
                                model: this.model,
                                isVisitor: window.OverDrive.isVisitor,
                            }).waitTimeHtml;
                        }
                    } else if (!this.model.get('isFastlane')) {
                        if (this.title.holdsRatio) {
                            waitingText = window.html('cover.waitingPerCopy', {
                                holdsRatio: this.title.holdsRatio,
                            });
                        } else if (this.title.holdsCount === 0) {
                            waitingText = window.html('cover.noHolds');
                        }
                    }
                }
                helpButtonHTML =
                    window.featureManager.isEnabled('LHTNG-2863') &&
                    !this.title.isOwned
                        ? ''
                        : ` <button
                    data-media-id="${this.title.id}"
                    aria-label="${window.html('cover.holdsRatioExplanation')}"
                    class="primary help-tip js-holds-ratio-help-icon ${notHeldClass}">
                    </button>
                    `;
            }
        }

        this.$el.append(
            CopiesAvailableTemplate({
                withIcons: this.withIcons,
                availabilityText,
                waitingText,
                helpButtonHTML,
            })
        );
    }

    _renderModal() {
        if (window.featureManager.isEnabled('LHTNG-2863')) {
            if (
                window.featureManager.isEnabled('betterPatronState')
                    ? this.model.get('isOnHold')
                    : this.model.get('titleState') === 'onHold'
            ) {
                window.ajax.getHold(this.model.get('id')).done((holdData) => {
                    // should be confirming that this is on hold
                    this.model.set({
                        holdsRatio: holdData.holdsRatio,
                        holdsCount: holdData.holdsCount,
                        holdListPosition: holdData.holdListPosition,
                    });
                    this.modal = new HoldInformationModalV2({
                        model: this.model,
                        el: this.el,
                    });
                });
            } else {
                this.modal = new HoldInformationModalV2({
                    model: this.model,
                    el: this.el,
                    hideHoldsLink: true,
                });
            }
        } else {
            const isFastlane = this.model.get('isFastlane');
            const titleState = this.model.get('titleState');
            if (!!isFastlane) {
                this.modal = new HoldInformationModal({
                    model: this.model,
                    type: 'basic',
                    el: this.el,
                });
            } else if (
                window.featureManager.isEnabled('betterPatronState')
                    ? this.model.get('isOnHold')
                    : this.model.get('titleState') === 'onHold'
            ) {
                window.ajax.getHold(this.model.get('id')).done((holdData) => {
                    // should be confirming that this is on hold
                    this.model.set({
                        holdsRatio: holdData.holdsRatio,
                        holdsCount: holdData.holdsCount,
                        holdListPosition: holdData.holdListPosition,
                    });
                    this.modal = new HoldInformationModal({
                        model: this.model,
                        type: 'successPosition',
                        el: this.el,
                    });
                });
            } else {
                this.modal = new HoldInformationModal({
                    model: this.model,
                    type: 'ratio',
                    el: this.el,
                });
            }
        }
    }
}
